module.exports = __webpack_public_path__ + "static/img/areaB_5.4aa1863.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_5.png
// module id = 1277
// module chunks = 1